import Header from '../../components/Header/Header';
import Menu from '../../components/Menu/Menu';
import NotAuthenticated from '../../components/NotAuthenticated/NotAuthenticated';
import useAuth from '../../hooks/useAuth';
import './About.scss';
export default function About() {
    const authenticated = useAuth();
    if (authenticated === false) {
        return <NotAuthenticated/>;
    }
    return (
        <div id="about">
            <div className="centered-container">
                {/* <h1>About Ratonera</h1> */}
                <p>
                ratonera.net web page
                </p>
                <Menu title="" options={[
                    { name: 'Go Back', path: '/..' },
                ]} />
            </div>
        </div>
    );
}